// Hook for managing rating modal state
import { useState, useEffect, useCallback } from 'react';
import { ratingApi } from '../api/ratingApi';

export const useRatingModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingExchange, setPendingExchange] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Check for pending ratings
  const checkForPendingRatings = useCallback(async () => {
    try {
      setIsLoading(true);
      const exchange = await ratingApi.checkPendingRatings();
      
      if (exchange) {
        setPendingExchange(exchange);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Failed to check pending ratings:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Allow opening modal manually from components (like ExchangeCard)
  const openModalForExchange = (exchange) => {
    setPendingExchange(exchange);
    setIsModalOpen(true);
  };

  // Submit rating handler
  const handleSubmitRating = async (exchangeId, rating) => {
    try {
      await ratingApi.submitExchangeRating(exchangeId, rating);
      setIsModalOpen(false);
      setPendingExchange(null);
      
      // Check for more pending ratings after a short delay
      setTimeout(checkForPendingRatings, 1000);
    } catch (error) {
      console.error('Failed to submit rating:', error);
      throw error;
    }
  };

  // Remind later handler
  const handleRemindLater = async (exchangeId) => {
    try {
      await ratingApi.setRatingReminder(exchangeId);
      setIsModalOpen(false);
      setPendingExchange(null);
      
      // Check for more pending ratings after a short delay
      setTimeout(checkForPendingRatings, 1000);
    } catch (error) {
      console.error('Failed to set reminder:', error);
      throw error;
    }
  };

  // Close modal handler
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPendingExchange(null);
  };

  // Check on mount and provide manual trigger
  useEffect(() => {
    checkForPendingRatings();
  }, [checkForPendingRatings]);

  return {
    isModalOpen,
    pendingExchange,
    isLoading,
    handleSubmitRating,
    handleRemindLater,
    handleCloseModal,
    checkForPendingRatings,
    openModalForExchange
  };
};